import * as React from "react";
import { getPathName } from "../../utils/utils";

const mappingPaths = ["/mapping/product"];

const MappingIcon = (props: any) => {
  const pathName = getPathName();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 36 36"
      {...props}
    >
      <path
        stroke={
          mappingPaths.includes(pathName)
            ? "var(--menuBarIconActive)"
            : "var(--menuBarIconDeactive)"
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d="M23.304 26.379a3.184 3.184 0 0 0-4.393 0 2.927 2.927 0 0 0 0 4.242 3.185 3.185 0 0 0 4.393 0m0 0c-1.207 1.167 1.213-1.171 0 0Zm0 0 2.19-2.115 2.19-2.128"
      />
      <path
        stroke={
          mappingPaths.includes(pathName)
            ? "var(--menuBarIconActive)"
            : "var(--menuBarIconDeactive)"
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d="m23.31 26.373 2.19 2.13 2.19 2.115m0 0c-1.207-1.168 1.213 1.17 0 0Zm0 0c1.207 1.169 3.18 1.172 4.393 0a2.927 2.927 0 0 0 0-4.242 3.184 3.184 0 0 0-4.393 0M21 4.5v6a1.5 1.5 0 0 0 1.5 1.5h6"
      />
      <path
        stroke={
          mappingPaths.includes(pathName)
            ? "var(--menuBarIconActive)"
            : "var(--menuBarIconDeactive)"
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d="M14.25 31.5H10.5a3 3 0 0 1-3-3v-21a3 3 0 0 1 3-3H21l7.5 7.5v9"
      />
    </svg>
  );
};
export default MappingIcon;
